import { registerBlockType } from "@wordpress/blocks";
import { Provider } from "react-redux";
import store from "store";
import { Icon } from "@wordpress/components";
import Editor from "./Edit";
import Save from "./Save";

registerBlockType("vino/product-collection", {
	title: "Products by Collection",
	icon: {
		src: <Icon icon="products" />,
	},
	category: "corksy",
	keywords: ["corksy"],
	description: "Display a grid of products from your selected collection.",
	edit: function (props) {
		return (
			<Provider store={store}>
				<Editor {...props} />
			</Provider>
		);
	},
	save: Save,
});
